import { withKeycloak } from "@react-keycloak/web";
import React from "react";
import { activeFilterPageInfo } from "../../../../../services/FilteringUtils";
import KnowledgeSourceClassificationService from "../../../../../services/KnowledgeSourceClassificationService";
import KnowledgeSourceService from "../../../../../services/KnowledgeSourceService";
import CommonUtil from "../../../../../utils/CommonUtil";
import {
  knowledgeValidationRules as validationRules,
  validateEntity
} from "../../../../../validators/validationRules";
import PageComponent from "../../../page/PageComponent";
import KnowledgeSource from "./KnowledgeSource";

class KnowledgeSourceContainer extends PageComponent {
  constructor(props) {
    super(props);
    this.state = this.initialState(this.state);
    this.knowledgeSourceService = new KnowledgeSourceService(this.keycloak);
    this.knowledgeSourceClassificationService = new KnowledgeSourceClassificationService(
      this.keycloak
    );
  }

  initialState = state => {
    return {
      ...state,
      newKnowledgeSource: {},
      disabled: true,
      knowledgeSourceClassifications: [],
      show: false
    };
  };

  componentDidUpdate(prevProps) {
    if (!this.state.isLoading && this.props.knowledgeItem?.id) {
      if (!("knowledgeSource" in this.props.knowledgeItem)) {
        this.loadKnowledgeSource();
      }

      if (
        prevProps.knowledgeItem &&
        !CommonUtil.jsonEquals(
          this.props.knowledgeItem,
          prevProps.knowledgeItem
        )
      ) {
      }
    }
  }

  componentDidMount() {
    super.componentDidMount();
    this.loadKnowledgeSourceClassifications();
  }

  loadKnowledgeSourceClassifications = () => {
    this.prepareCall(
      this.knowledgeSourceClassificationService.getEntities(
        activeFilterPageInfo,
        this.sortInfo,
        this.onKnowledgeSourceClassificationsLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onKnowledgeSourceClassificationsLoad = data => {
    const dataContent = CommonUtil.getDataContent(data);
    if (dataContent) {
      const knowledgeSourceClassifications = dataContent;
      this.setState({
        knowledgeSourceClassifications: knowledgeSourceClassifications
      });
    }
  };

  loadKnowledgeSource = () => {
    this.setState({ isLoading: true });
    const url = this.props.knowledgeItem._links.knowledgeSources.href;
    this.prepareCall(
      this.knowledgeSourceService.getEntitiesByUrl(
        url,
        this.onKnowledgeSourceLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onKnowledgeSourceLoad = data => {
    let knowledgeSource;
    const dataContent = CommonUtil.getDataContent(data);
    if (dataContent) {
      knowledgeSource = dataContent[0];
    }
    this.props.setInitialEntityPropertyState(
      "knowledgeSource",
      knowledgeSource
    );
    this.setState({
      isLoading: false,
      knowledgeSource: knowledgeSource
    });

    this.loadKnowledgesourceClassification(knowledgeSource);
  };

  onChange = event => {
    const knowledgeSource = event.target.value;
    this.setState({ knowledgeSource });
    this.props.onChange(event);
    this.loadKnowledgesourceClassification(knowledgeSource);
  };

  loadKnowledgesourceClassification(knowledgeSource) {
    if (knowledgeSource?._links?.knowledgeSourceClassification) {
      this.prepareCall(
        this.knowledgeSourceClassificationService.getEntitiesByUrl(
          knowledgeSource._links.knowledgeSourceClassification.href,
          this.onKnowledgeSourceClassificationLoad,
          this.messageHandler.handleError
        )
      );
      this.performCalls();
    }
  }

  onKnowledgeSourceClassificationLoad = data => {
    const dataContent = CommonUtil.getDataContent(data);
    if (dataContent) {
      const knowledgeSource = this.state.knowledgeSource;
      knowledgeSource.knowledgeSourceClassification = dataContent[0];
      this.setState({ knowledgeSource });
    }
  };

  handleShow = () => {
    this.setState({
      show: true
    });
  };

  handleClose = () => {
    this.setState({
      show: false
    });
  };

  onSave = entity => {
    const newKnowledgeSource = { ...this.state.newKnowledgeSource };

    this.onChange({
      target: {
        id: "knowledgeSource",
        value: newKnowledgeSource
      }
    });
    this.handleClose();
  };

  onNewKnowledgeSourceChange = event => {
    const { newKnowledgeSource } = this.state;
    newKnowledgeSource[event.target.id] = event.target.value;
    const disabled = !this.validator(newKnowledgeSource);
    this.setState({ newKnowledgeSource, disabled });
  };

  validator = entity => {
    return validateEntity(entity, validationRules.generalData);
  };

  render() {
    const maxLength = {
      name: 1024,
      uri: 2000,
      institution: 1024,
      description: 2000
    };
    return (
      <KnowledgeSource
        knowledgeSourceClassifications={
          this.state.knowledgeSourceClassifications
        }
        {...this.handlerProps()}
        processes={this.props.processes}
        onChange={this.onChange}
        knowledgeSource={this.state.knowledgeSource}
        editable={this.props.editable}
        maxLength={maxLength}
        handleShow={this.handleShow}
        handleClose={this.handleClose}
        show={this.state.show}
        onSave={this.onSave}
        onNewKnowledgeSourceChange={this.onNewKnowledgeSourceChange}
        newKnowledgeSource={this.state.newKnowledgeSource}
        validationRules={validationRules.generalData}
        disabled={this.state.disabled}
      />
    );
  }
}

export default withKeycloak(KnowledgeSourceContainer);
